import type { SessionProfile } from '@/types';

export function canManageThreatProtection(session: SessionProfile | null, tenant: string) {
  return session?.features?.tenant?.[tenant]?.['threat.protection.enabled'] === true && (!!session.permissionSummary?.global?.includes('platform.manage') || !!session.permissionSummary?.tenants?.[tenant]?.includes('tenant.manage'));
}
